module.exports = __webpack_public_path__ + "static/media/sparkle.d39298de.webm";